import { useNotify } from '@hotjar/hotsauce';
import { useCallback } from 'react';

export const useCopyLink = (): ((route: string) => Promise<void>) => {
  const { showToast } = useNotify();
  const copyLinkToClipboard = useCallback(
    async (route: string) => {
      try {
        await navigator.clipboard.writeText(route);
        showToast({ kind: 'success', text: 'Copied link to clipboard' });
      } catch {
        showToast({ kind: 'danger', text: 'Could not copy link to clipboard' });
      }
    },
    [showToast],
  );

  return copyLinkToClipboard;
};
